import { NgModule } from "@angular/core";
import { ClickOutsideDirective } from "./click-outside.directive";
import { ImageIconDirective } from "./image-icon.directive";
import { PasswordEyeDirective } from './password-eye.directive';
import { SortDirective } from "./sort.directive";

const DIRECTIVES = [
  ClickOutsideDirective,
  PasswordEyeDirective,
  ImageIconDirective,
  SortDirective,
]

@NgModule({
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES]
})
export class DirectivesModule { }
